import { EPlayerType, IStreamConfig } from '@customTypes/common';

export const getPlayerTypesByStreamConfig: (streamConfig: IStreamConfig) => EPlayerType[] = (
  streamConfig,
) => {
  const availablePlayerTypes: EPlayerType[] = [];

  if (streamConfig.HLSStreamUrl) {
    availablePlayerTypes.push(EPlayerType.HLS);
  }

  if (streamConfig.WebRTCStreamId && streamConfig.WebRTCSignallingUrl) {
    availablePlayerTypes.push(EPlayerType.WEBRTC);

    if (streamConfig.MediaStream) {
      availablePlayerTypes.push(EPlayerType.BROADCAST);
    }
  }

  if (streamConfig.NativeStreamURL) {
    availablePlayerTypes.push(EPlayerType.NATIVE);
  }

  return availablePlayerTypes;
};
